<template>
	<div>
		<v-container class="global-margin">
      		<v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
	  	</v-container>
		<v-container id="top" class="content-wrap pt-0 mt-0">
			<v-row class="pa-3 pt-0">
				<v-col cols="12" md="4" v-for="i in notice" :key="i.id">
					<v-card shaped flat class="article-card card-link" dark color="#094776">
						<v-card-subtitle class="flex-left">
							<v-icon class="mr-3">calendar_today</v-icon>
							<p class="mb-0">{{ i.created_at }}</p>
						</v-card-subtitle>
						<v-card-text class="headline font-weight-bold">{{i.title}}</v-card-text>
						<v-card-actions class="card-link-action pb-5 pl-4">
							<v-btn color="white" link :to="'/novosti/' + i.alias" rounded light class="pa-6 moodle-btn text-capitalize">
								Pročitaj više</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
			<v-row class="flex-center w-100 ma-0">
				<v-col cols="12" md="10" v-for="(item, i) in news" :key="i" class="w-100 flex-center">
					<v-card shaped flat class="article-card w-100" :to="'/novosti/' + item.alias">
						<v-row class="flex-left w-100 ma-0">
							<v-col cols="12" md="4" class="pa-0 ma-0 article-img-wrap">
								<v-img class="white--text article-img" v-if="item.image"
								       :src="'https://web-admin.sum.ba/api/storage/' + item.image"></v-img>
							</v-col>
							<v-col cols="12" md="">
								<v-card-subtitle class="pb-0 font-weight-regular text--secondary">Novosti</v-card-subtitle>
								<v-card-title class="pt-0">
									<h2 class="pt-0 title my-6" style="line-height: 1.2 !important; color: #084776">
										{{item.title}}</h2>
								</v-card-title>
								<v-card-text class="text--secondary" v-html="item.content.slice(0,250) + '...'"></v-card-text>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<v-row align="center" justify="center" class="flex-center w-100 mt-5">
				<v-col cols="6" class="text-center">
					<div class="text-center">
						<v-pagination
						v-model="page"
						@change="getNews()"
						:total-visible="5"
						:length="pagination_num"
						circle
						color="#084776"
						></v-pagination>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
export default {
    data() {
        return {
            news: [],
            notice: [],
            pagination_num: 0,
			page: 1,
			breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
        },
        {
          text: 'Novosti',
          disabled: true,
        },
      ],
        };
    },

    mounted() {
		this.getPaginationNum();
        this.getNews();
		this.getNotice();
    },

    methods: {
        getNews() {
            let requestBody = {
                page: this.page,
                postsPerPage: 5,
                categories: ["e-Škola"]
            };

            axios
                .post("https://web-admin.sum.ba/api/web/objave", requestBody)
                .then(response => {
                    this.news = response.data;
                    // console.log(this.news);
                })
                .catch(error => console.log(error.message));
        },
        getNotice() {
            let requestBody = {
                page: this.page,
                postsPerPage: 8,
                categories: ["e-škola corona"]
            };

            axios
                .post("https://web-admin.sum.ba/api/web/objave", requestBody)
                .then(response => {
                    this.notice = response.data;
                    //   console.log(this.news);
                })
                .catch(error => console.log(error.message));
		},
		getPaginationNum() {
		let requestBody = {
			postsPerPage: 5,
			alias: 'e-skola'
		};

		axios
			.post("https://web-admin.sum.ba/api/web/stranice", requestBody)
			.then(response => {
			this.pagination_num = response.data;
			})
			.catch(error => console.log(error.message));
		},
	},
	watch: {
		page: {
			handler() {
				this.getNews();
				this.$vuetify.goTo('#top')
			}
		},
	}
};
</script>

<style lang="scss" scoped>
	.popis-novosti {
		margin-top: 150px;
	}

	@media (max-width: 768px) {
		.popis-novosti {
			margin-top: 120px !important;
		}
	}

	.card-link {
		position: relative;
	}

	.img-border {
		border-top-left-radius: 25px;
		border-bottom-left-radius: 4px;
	}

	.moodle-btn {
		letter-spacing: 0 !important;
		border-radius: 30px;
		position: absolute;
		bottom: 25px;
	}
	.article-card {
		min-height: 300px;
		width: 100%;
		overflow: hidden;
		.article-img-wrap {
			display: inline-block;
			overflow: hidden;
			height: 300px;
			.article-img {
				transition: transform .4s;
				height: 100%;
			}
		}
		&:hover {
			.article-img {
				transform: scale(1.1);
				transform-origin: 50% 50%;
			}
		}
	}
</style>
